import { SET_LANGUAGE } from "./types";

// SET LANGUAGE
export const setLanguage = (result: any): any => (dispatch: any) => {
    dispatch({ type: SET_LANGUAGE, payload: result })
};
